<div class="curva-abc-venda-filter">
  <div class="curva-abc-venda-filter-quick">
    <div
      class="curva-abc-venda-filter-quick-block curva-abc-venda-filter-quick-block-options"
    >
      <div class="curva-abc-venda-filter-quick-block-data">
        <!-- Data de Emissão -->
        <sgt-datepicker
          [(ngModel)]="filter.dataEmissaoInicial"
          [(startDate)]="filter.dataEmissaoInicialPeriodo"
          [(endDate)]="filter.dataEmissaoFinalPeriodo"
          name="dataEmissaoFilter"
          id="dataEmissaoFilter"
          #dataEmissaoFilter="ngModel"
          #dataEmissaoDatepicker
          [ngControl]="dataEmissaoFilter"
          [mode]="dataEmissaoDatepickerMode"
          [showBtnCalendar]="false"
          inputPrependText="Emissão"
          [withNavigation]="true"
          [showPeriodicidadeDiaria]="true"
          [showPeriodicidadeMensal]="true"
          [showPeriodicidadeTrimestral]="true"
          [showPeriodicidadeSemestral]="true"
          [showPeriodicidadeAnual]="true"
          [showPeriodicidadePeriodo]="true"
          [(periodicidade)]="filter.periodicidadeEmissao"
          [(mes)]="filter.mesEmissao"
          [(trimestre)]="filter.trimestreEmissao"
          [(semestre)]="filter.semestreEmissao"
          [(ano)]="filter.anoEmissao"
          (ngModelChange)="onChangeDataEmissao()"
          (startDateChange)="onChangeDataEmissaoInicialPeriodo()"
          (endDateChange)="onChangeDataEmissaoFinalPeriodo()"
        >
        </sgt-datepicker>
      </div>

      <!-- Statuses Pedidos -->
      <div
        class="curva-abc-venda-filter-quick-block-options-multiselect-item"
        *ngIf="filter.isReferenciaPedido()"
      >
        <sgt-pedido-status-multiselect
          [(status)]="filter.statusesPedidos"
          (statusChange)="onChangeStatusesPedidos()"
          defaultTitle="Status dos Pedidos"
        >
        </sgt-pedido-status-multiselect>
      </div>

      <!-- Representantes -->
      <div
        class="curva-abc-venda-filter-quick-block-options-multiselect-item"
        *ngIf="!isRepresentante"
      >
        <sgt-representante-multiselect
          [(idsRepresentantes)]="filter.idsRepresentantes"
          (idsRepresentantesChange)="onChangeRepresentantes()"
          [(somenteAtivos)]="filter.somenteRepresentantesAtivos"
          defaultTitle="Representantes"
          [disabled]="!(initialization.initialized | async)"
        >
        </sgt-representante-multiselect>
      </div>

      <!-- Classificações de Clientes -->
      <div class="curva-abc-venda-filter-quick-block-options-multiselect-item">
        <sgt-classificacao-tipo-multiselect
          [(idsClassificacoes)]="filter.idsClassificacoesClientes"
          (idsClassificacoesChange)="onChangeClassificacoesClientes()"
          [(nullOption)]="filter.classificacaoClienteNull"
          [showNullOption]="true"
          [tipoClassificacaoCadastroCliente]="true"
          [pullRight]="true"
          defaultTitle="Segmentos de Clientes"
          checked="Segmento de Cliente"
          checkedPlural="Segmentos de Clientes"
          [disabled]="!(initialization.initialized | async)"
        >
        </sgt-classificacao-tipo-multiselect>
      </div>

      <!-- Classificações de Itens -->
      <div class="curva-abc-venda-filter-quick-block-options-multiselect-item">
        <sgt-classificacao-tipo-multiselect
          [(idsClassificacoes)]="filter.idsClassificacoesItens"
          (idsClassificacoesChange)="onChangeClassificacoesItens()"
          [(nullOption)]="filter.classificacaoItemNull"
          [showNullOption]="true"
          [tipoClassificacaoCadastroItem]="true"
          [pullRight]="true"
          defaultTitle="Segmentos de Itens"
          checked="Segmento de Item"
          checkedPlural="Segmentos de Itens"
          [disabled]="!(initialization.initialized | async)"
        >
        </sgt-classificacao-tipo-multiselect>
      </div>

      <ng-container *ngIf="!isRepresentante">
        <!-- Gerentes -->
        <div class="curva-abc-venda-filter-quick-block-options-multiselect-item">
          <sgt-usuario-multi-select
            [(ngModel)]="filter.idsGerentes"
            name="gerentes"
            [perfil]="EnumUsuarioPerfil.GERENTE"
            [situacao]="EnumSituacao.ATIVO"
            [settings]="{
              placeholder: 'Gerentes',
              singular: 'Gerente',
              plural: 'Gerentes',
              searchEmptyResultMessage: 'Nenhum gerente encontrado',
              showFooter: false
            }"
            (changed)="onChangeGerentes()"
            [disabled]="!(initialization.initialized | async)"
          >
          </sgt-usuario-multi-select>
        </div>

        <!-- Atendentes -->
        <div class="curva-abc-venda-filter-quick-block-options-multiselect-item">
          <sgt-usuario-multi-select
            [(ngModel)]="filter.idsAtendentes"
            name="atendentes"
            [perfil]="EnumUsuarioPerfil.ATENDENTE"
            [situacao]="EnumSituacao.ATIVO"
            [settings]="{
              placeholder: 'Atendentes',
              singular: 'Atendente',
              plural: 'Atendentes',
              searchEmptyResultMessage: 'Nenhum atendente encontrado',
              showFooter: false
            }"
            (changed)="onChangeAtendentes()"
            [disabled]="!(initialization.initialized | async)"
          >
          </sgt-usuario-multi-select>
        </div>
      </ng-container>

      <div class="curva-abc-venda-filter-quick-block-options-btns">
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-light"
            (click)="refresh()"
            title="Atualizar"
            [disabled]="!(initialization.initialized | async)"
          >
            <i class="fas fa-sync"></i>
          </button>
          <button
            type="button"
            class="btn btn-light"
            (click)="clear()"
            title="Limpar filtro e atualizar"
            [disabled]="!(initialization.initialized | async)"
          >
            <i class="fas fa-eraser" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            class="btn"
            [class.btn-light]="!filter.isFilterDirty"
            [class.btn-danger]="filter.isFilterDirty"
            (click)="toggleCollapse()"
            title="Filtro avançado"
            [disabled]="!(initialization.initialized | async)"
          >
            <ng-template [ngIf]="initialization.initialized">
              <i class="fas fa-filter" aria-hidden="true"></i>
              <i [class]="collapseIcon" aria-hidden="true"></i>
            </ng-template>
            <ng-template [ngIf]="!(initialization.initialized | async)">
              <i class="fas fa-spinner fa-pulse"></i>
            </ng-template>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="curva-abc-venda-filter-collapse" #filterCollapse>
    <div class="row">
      <div class="form-group col-12 col-md" *ngIf="isShowClienteFilter">
        <label for="pessoa" class="col-form-label">Cliente</label>
        <sgt-typeahead-cliente-pessoa
          [(ngModel)]="filter.pessoa"
          name="pessoa"
          id="pessoa"
          #pessoa="ngModel"
          [ngControl]="pessoa"
          (typeaheadChange)="onChangeCliente($event)"
        >
        </sgt-typeahead-cliente-pessoa>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12">
        <label for="item" class="col-form-label">Item</label>
        <sgt-typeahead-item
          [(ngModel)]="filter.item"
          name="item"
          id="item"
          #item="ngModel"
          [ngControl]="item"
          [dropup]="true"
          [ignorarRepresentante]="true"
          (typeaheadChange)="onChangeItem($event)"
        >
        </sgt-typeahead-item>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-6">
        <label for="estado" class="col-form-label">Estados</label>
        <sgt-estado-multiselect
          [(idsEstados)]="filter.idsEstados"
          (idsEstadosChange)="onChangeEstados($event)"
        >
        </sgt-estado-multiselect>
      </div>
      <div class="form-group col-12 col-md-6">
        <label for="cidade" class="col-form-label">Cidade</label>
        <sgt-typeahead-cidade
          [(ngModel)]="filter.cidade"
          name="cidade"
          id="cidade"
          #cidade="ngModel"
          [ngControl]="cidade"
          [dropup]="true"
          (typeaheadChange)="onChangeCidade($event)"
        >
        </sgt-typeahead-cidade>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-12 col-md-6">
        <label for="tagsClientes" class="col-form-label">Tags de Clientes</label>
        <sgt-tags-multi-select
          [(ngModel)]="filter.idsTagsClientes"
          name="tagsClientes"
          id="tagsClientes"
          [cadastros]="tagCadastroCliente"
          [situacoes]="tagSituacaoAtivo"
          [settings]="{
            placeholder: 'Selecione as tags',
            singular: 'Tag de Cliente',
            plural: 'Tags de Clientes',
            searchEmptyResultMessage: 'Nenhuma tag encontrada',
            showFooter: false
          }"
          (changed)="onChangeTagsClientes()"
          [disabled]="!(initialization.initialized | async)"
        >
        </sgt-tags-multi-select>
      </div>
      <div class="form-group col-12 col-md-6">
        <label for="tagsItens" class="col-form-label">Tags de Itens</label>
        <sgt-tags-multi-select
          [(ngModel)]="filter.idsTagsItens"
          name="tagsItens"
          id="tagsItens"
          [cadastros]="tagCadastroItem"
          [situacoes]="tagSituacaoAtivo"
          [settings]="{
            placeholder: 'Selecione as tags',
            singular: 'Tag de Item',
            plural: 'Tags de Itens',
            searchEmptyResultMessage: 'Nenhuma tag encontrada',
            showFooter: false
          }"
          (changed)="onChangeTagsItens()"
          [disabled]="!(initialization.initialized | async)"
        >
        </sgt-tags-multi-select>
      </div>
    </div>
  </div>
</div>
